// Calendars API service for team sharing

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const calendarsApi = {
  // Save a generated calendar
  async saveCalendar(calendarData) {
    try {
      const response = await fetch(`${API_URL}/api/calendars/save`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(calendarData),
      });
      
      if (!response.ok) {
        throw new Error('Failed to save calendar');
      }
      return await response.json();
    } catch (error) {
      console.error('Error saving calendar:', error);
      throw error;
    }
  },

  // Get user's calendars (including team calendars)
  async getCalendars(userId, userEmail = null, includeTeam = true, limit = 20) {
    try {
      let url = `${API_URL}/api/calendars/user/${userId}?include_team=${includeTeam}&limit=${limit}`;
      if (userEmail) {
        url += `&user_email=${encodeURIComponent(userEmail)}`;
      }
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Failed to fetch calendars');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching calendars:', error);
      return { calendars: [], is_premium: false };
    }
  },

  // Get a specific calendar
  async getCalendar(calendarId, userId, userEmail = null) {
    try {
      let url = `${API_URL}/api/calendars/${calendarId}?user_id=${userId}`;
      if (userEmail) {
        url += `&user_email=${encodeURIComponent(userEmail)}`;
      }
      const response = await fetch(url);
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.detail || 'Failed to fetch calendar');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching calendar:', error);
      throw error;
    }
  },

  // Delete a calendar
  async deleteCalendar(calendarId, userId) {
    try {
      const response = await fetch(`${API_URL}/api/calendars/${calendarId}?user_id=${userId}`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        throw new Error('Failed to delete calendar');
      }
      return await response.json();
    } catch (error) {
      console.error('Error deleting calendar:', error);
      throw error;
    }
  },

  // Update a calendar (e.g., mark posts as posted)
  async updateCalendar(calendarId, userId, updates) {
    try {
      const response = await fetch(`${API_URL}/api/calendars/${calendarId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          ...updates,
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to update calendar');
      }
      return await response.json();
    } catch (error) {
      console.error('Error updating calendar:', error);
      throw error;
    }
  },

  // Get all calendars from team members
  async getTeamCalendars(teamId, userId, limit = 100) {
    try {
      const response = await fetch(`${API_URL}/api/teams/${teamId}/calendars?user_id=${userId}&limit=${limit}`);
      if (!response.ok) {
        throw new Error('Failed to fetch team calendars');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching team calendars:', error);
      return { calendars: [] };
    }
  },
};
